"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleFutures = exports.OrderInnerStatus = void 0;
var OrderInnerStatus;
(function (OrderInnerStatus) {
    OrderInnerStatus["Initialize"] = "initialize";
    OrderInnerStatus["CreateStrategy"] = "create_strategy";
    OrderInnerStatus["AllocateFund"] = "allocate_fund";
    OrderInnerStatus["MainLoop"] = "main_loop";
    OrderInnerStatus["ClosePosition"] = "close_position";
    OrderInnerStatus["ClearStrategy"] = "clear_strategy";
    OrderInnerStatus["PreTransfer"] = "pre-transfer";
    OrderInnerStatus["Transfering"] = "transfering";
    OrderInnerStatus["TransferIn"] = "transfer_in";
    OrderInnerStatus["TransferOut"] = "transfer_out";
    OrderInnerStatus["Canceled"] = "canceled";
})(OrderInnerStatus = exports.OrderInnerStatus || (exports.OrderInnerStatus = {}));
var SimpleFutures;
(function (SimpleFutures) {
    /** 订单状态 */
    let OrderStatus;
    (function (OrderStatus) {
        /** 默认值，运行中的仓位列表 */
        OrderStatus["running"] = "running";
        /** 历史仓位列表 */
        OrderStatus["finished"] = "finished";
    })(OrderStatus = SimpleFutures.OrderStatus || (SimpleFutures.OrderStatus = {}));
    /** tpsl止盈止损的模式 */
    let TPSLMode;
    (function (TPSLMode) {
        /** 追踪模式 */
        TPSLMode["simple_trailing"] = "simple_trailing";
        /** 按收益率模式 */
        TPSLMode["simple_rate"] = "simple_rate";
    })(TPSLMode = SimpleFutures.TPSLMode || (SimpleFutures.TPSLMode = {}));
    let TPSLStateEnum;
    (function (TPSLStateEnum) {
        TPSLStateEnum["not_set"] = "not_set";
        TPSLStateEnum["normal"] = "normal";
        TPSLStateEnum["too_high"] = "too_high";
        TPSLStateEnum["too_low"] = "too_low";
    })(TPSLStateEnum = SimpleFutures.TPSLStateEnum || (SimpleFutures.TPSLStateEnum = {}));
})(SimpleFutures = exports.SimpleFutures || (exports.SimpleFutures = {}));
